import { Panel } from 'primereact/panel';
import * as generic from '../../../../components/Generico';
import { ReferenciaPersonal } from '../../../../components/trust/ReferenciaPersonal';
import { ReferenciaBancaria } from '../../../../components/trust/ReferenciaBancaria';
import { ReferenciaComercial } from '../../../../components/trust/ReferenciaComercial';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const Referencias = ({ toast, id, permss, soloLectura, handlePrev, handleNext }) => {

    return (
        <>
            <Panel header={generic.renderPanelHeader('D', 'REFERENCIAS', 'pi pi-address-book')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <div className="p-2">
                    <ReferenciaPersonal id={id} toast={toast} permss={permss} soloLectura={soloLectura} tipo="proveedorPn" />
                </div>
                <div className="p-2">
                    <ReferenciaBancaria id={id} toast={toast} permss={permss} soloLectura={soloLectura} tipo="proveedorPn" />
                </div>
                <div className="p-2">
                    <ReferenciaComercial id={id} toast={toast} permss={permss} soloLectura={soloLectura} tipo="proveedorPn" />
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" onNext={handleNext} onPrev={handlePrev} isReadOnly={true} />
        </>
    );
}
